const fiscalDataGateDictEN = {
  fiscalGateTitle: "Complete your fiscal data",
  fiscalGateDescription:
    "To keep using the platform and allow us to automatically issue your electronic invoice, we need you to complete your fiscal data.",
  personType: "Person type",
  personTypePhysical: "Individual",
  personTypeLegal: "Company",
  nomeFiscal: "Company name",
  fiscalDocumentNumber: "Fiscal document (Codice Fiscale or Partita IVA)",
  fiscalDocumentNumberCPF: "CPF",
  fiscalDocumentNumberCNPJ: "CNPJ",
  fiscalDocumentNumberCodiceFiscale: "Codice Fiscale",
  fiscalDocumentNumberPartitaIVA: "Partita IVA",
  fiscalAddress: "Address",
  fiscalGateUnexpectedError: "Unexpected error while saving your fiscal data.",
  fiscalGateSuccess: "Fiscal data saved successfully.",
};

export default fiscalDataGateDictEN;
